import { DataExportOptions } from './data-export-options';

/**
 * Data export options for JSON format.
 */
export class JsonDataExportOptions extends DataExportOptions {}
